import styled from 'styled-components';

export const SortableSettingRowStyle = styled.div<{ $isDragging: boolean; $isOver: boolean; $isSelected?: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px;
  border-bottom: 1px solid #edf0f4;
  border-left: 3px solid ${({ $isSelected }) => ($isSelected ? 'var(--settings-accent)' : 'transparent')};
  background: ${({ $isSelected, $isOver }) => ($isOver ? '#e9e2fc' : $isSelected ? '#f4f1fc' : '#fff')};
  box-shadow: ${({ $isOver }) => ($isOver ? 'inset 0 2px var(--settings-accent)' : 'none')};
  opacity: ${({ $isDragging }) => ($isDragging ? 0.45 : 1)};
  &:last-child {
    border-bottom: 0;
  }
  .sort-handle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 36px;
    padding: 0;
    border: 0;
    background: transparent;
    color: #8792a2;
    cursor: grab;
    font-size: 17px;
    flex-shrink: 0;
  }
  .sort-handle:disabled {
    cursor: default;
    opacity: 0.35;
  }
  .sort-content {
    flex: 1;
    min-width: 0;
  }
`;
